import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FitGymTrackLogoFull } from '../../assets/branding/fitgymtrack-logo-completo.svg';
import { ReactComponent as FitGymTrackLogoIcon } from '../../assets/branding/fitgymtrack-logo-icona.svg';

const GymLogo = ({ className = "", variant = "full" }) => {
    const { t } = useTranslation();

    const aria = t('common.appName');
    if (variant === "icon") {
        return (
            <FitGymTrackLogoIcon
                aria-label={aria}
                role="img"
                className={`h-16 w-16 shrink-0 ${className}`}
            />
        );
    }

    return (
        <FitGymTrackLogoFull
            aria-label={aria}
            role="img"
            className={`h-14 w-auto max-w-[min(100%,260px)] shrink-0 ${className}`}
        />
    );
};

export default GymLogo;
